"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  primary: {
    root: {},
    button: {
      width: '160px',
      height: '2.5em'
    },
    map: {}
  },
  test: {
    root: {
      backgroundColor: 'browngrey',
      height: '20px'
    },
    button: {
      backgroundColor: 'browngrey',
      borderRadius: '3px'
    },
    map: {
      backgroundColor: 'browngrey'
    }
  }
};
exports.default = _default;